export const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'https://dev.dms-suite.com/api'
export const apiAuthBaseUrl = process.env.REACT_APP_AUTH_BASE_URL || 'https://dev.dms-suite.com/auth'
export const apiMmsBaseUrl = process.env.REACT_APP_MMS_BASE_URL || 'https://dev.dms-suite.com/mms'
export const workerBaseUrl = process.env.REACT_APP_WORKER_BASE_URL || 'https://dev.dms-suite.com/worker'
export const appName = 'DMS Suite 2026 v.3.1.2'
